import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@material-ui/core/Grid/Grid";
import MakeYourShop from "./components/MakeYourShop";
import MakeYourFirstProduct from "./components/MakeYourFirstProduct";
import Title from "../../components/elements/Title";
import Clock from "../../components/elements/Clock";
import PeopleRoundedIcon from '@material-ui/icons/PeopleRounded';
import AppCard from "../../components/layouts/components/AppCard";
import Role from "../../components/elements/Role";
import ShopRoundedIcon from '@material-ui/icons/ShopRounded';
import Button from "@material-ui/core/Button/Button";
import {Link} from "react-router-dom";
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import ShoppingCartRoundedIcon from '@material-ui/icons/ShoppingCartRounded';
import OrderImage from '../../../files/img/dashboard/order.png'
import UsersImage from '../../../files/img/dashboard/people.png'
import ProductImage from '../../../files/img/dashboard/product.png'
import ShopImage from '../../../files/img/dashboard/shop.png'

class Dashboard extends React.Component {
    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.dashboard}>
                <Grid container spacing={4} justify="center" className="mt-20">
                    <Role type="admin">
                        <Grid item xs={12} md={5} >
                            <AppCard
                                style={{height:"100%"}}>
                                <div className="dashboard-card">
                                    <img src={ShopImage} alt="shop"/>
                                    <Title style={{fontSize:30}}>{Translate.manageShops}</Title>
                                    <Button
                                        component={Link}
                                        color="secondary"
                                        to="/manage/manage-shops"
                                        size="small"
                                        endIcon={<ArrowBackRoundedIcon/>}
                                    >
                                        {Translate.view}
                                    </Button>
                                </div>
                            </AppCard>
                        </Grid>
                        <Grid item xs={12} md={5} >
                            <AppCard
                                style={{height:"100%"}}>
                                <div className="dashboard-card">
                                    <img src={ProductImage} alt="shop"/>
                                    <Title style={{fontSize:"20px !important"}}>{Translate.manageProducts}</Title>
                                    <Button
                                        component={Link}
                                        color="secondary"
                                        size="small"
                                        to="/manage/manage-products"
                                        endIcon={<ArrowBackRoundedIcon/>}
                                    >
                                        {Translate.view}
                                    </Button>
                                </div>
                            </AppCard>
                        </Grid>
                        <Grid item xs={12} md={5} >
                            <AppCard
                                style={{height:"100%"}}>
                                <div className="dashboard-card">
                                    <img src={OrderImage} alt="shop"/>
                                    <Title style={{fontSize:30}}>{Translate.manageOrders}</Title>
                                    <Button
                                        component={Link}
                                        color="secondary"
                                        to="/manage/orders"
                                        size="small"
                                        endIcon={<ArrowBackRoundedIcon/>}
                                    >
                                        {Translate.view}
                                    </Button>
                                </div>
                            </AppCard>
                        </Grid>
                        <Grid item xs={12} md={5} >
                            <AppCard
                                style={{height:"100%"}}>
                                <div className="dashboard-card">
                                    <img src={UsersImage} alt="shop"/>
                                    <Title style={{fontSize:"20px !important"}}>{Translate.allUsers}</Title>
                                    <Button
                                        component={Link}
                                        color="secondary"
                                        size="small"
                                        to="/manage/users/view/all"
                                        endIcon={<ArrowBackRoundedIcon/>}
                                    >
                                        {Translate.view}
                                    </Button>
                                </div>
                            </AppCard>
                        </Grid>
                    </Role>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withStyles(Styles)(Dashboard);